export const SPECIAL_CHAR_REGEX = /[!@#$%^&*(),.?":{}|<>\-_+=[\];'/\\`~]/;

export const validatePassword = (password: string): string[] => {
  const errors: string[] = [];

  if (password.length < 8 || password.length > 128) {
    errors.push('Between 8 and 128 characters');
  }

  if (!/[a-z]/.test(password)) {
    errors.push('One lowercase letter');
  }

  if (!/[A-Z]/.test(password)) {
    errors.push('One uppercase letter');
  }

  if (!/[0-9]/.test(password)) {
    errors.push('One number');
  }

  if (!SPECIAL_CHAR_REGEX.test(password)) {
    errors.push('One special character');
  }

  return errors;
};
